webpackJsonp([34,21],{

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormError_vue__ = __webpack_require__(189);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc19256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormError_vue__ = __webpack_require__(195);
function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc19256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormError',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(194);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("75a52f96", content, true, {});

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".form-error{background-color:#fae0e5;border:1px solid #ed3a4f;border-radius:4px;text-align:center;padding:8px}.form-error .error-ico{float:left;width:22px}.form-error .error-msg{font-family:ProximanovaRegular;font-size:14px}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Templates/FormError.vue"],"names":[],"mappings":"AACA,YAAY,yBAAyB,yBAAyB,kBAAkB,kBAAkB,WAAW,CAC5G,AACD,uBAAuB,WAAW,UAAU,CAC3C,AACD,uBAAuB,+BAAiC,cAAc,CACrE","file":"FormError.vue","sourcesContent":["\n.form-error{background-color:#fae0e5;border:1px solid #ed3a4f;border-radius:4px;text-align:center;padding:8px\n}\n.form-error .error-ico{float:left;width:22px\n}\n.form-error .error-msg{font-family:\"ProximanovaRegular\";font-size:14px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-error"},[_c('p',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Slots_Popup_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Templates_Loading_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Templates_FormError_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Utility__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PopupResetPassword",
  props: {
    closePopupCB: {
      type: Function
    }
  },
  data: function data() {
    return {
      width: "35%",
      userEmail: "",
      classValidateEmail: "",
      showLoading: false,
      formError: null,
      userEmailError: "",
      showSuccessMessage: null,
      header: "Forgot Password?"
    };
  },

  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_1__components_Slots_Popup_vue__["default"],
    Loading: __WEBPACK_IMPORTED_MODULE_2__components_Templates_Loading_vue__["default"],
    FormError: __WEBPACK_IMPORTED_MODULE_4__components_Templates_FormError_vue__["default"]
  },
  mounted: function mounted() {
    this.initTemplate();
  },

  watch: {
    formError: function formError(value) {
      var _this = this;

      if (value) {
        setTimeout(function () {
          _this.formError = null;
        }, 5000);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["actResetPassword"]), {
    initTemplate: function initTemplate() {
      // this.$refs.userEmail.focus();
    },
    resetPasswordCB: function resetPasswordCB() {
      var _this2 = this;

      // Check for form's validity
      if (!this.isFormValid()) return;
      this.showLoading = true;

      // If form in valid
      this.actResetPassword({
        email: this.userEmail
      }).then(function (response) {
        _this2.showLoading = false;
        // If error occured
        if (response.error) {
          // Clear the form
          _this2.userEmail = "";

          // Show password reset failed popup message
          _this2.formError = response.reason;
        } else {
          _this2.showSuccessMessage = "We have sent you an email with reset instructions";
          _this2.header = "Success";
        }
      }).catch(function (error) {
        _this2.showLoading = false;
        // Show password reset failed popup message
        _this2.formError = error;
      });
    },
    isFormValid: function isFormValid() {
      return this.validateEmailInput();
    },
    validateEmailInput: function validateEmailInput() {
      var maxChar = 64;
      // validateEmail method was defined in Utility mixin
      if (!this.userEmail) {
        this.userEmailError = "Please enter Email";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (!this.validateEmail(this.userEmail)) {
        this.userEmailError = "Invalid Email Id.Please enter in format xxx@yyy.com";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (this.userEmail.length > maxChar) {
        this.userEmailError = "E-mail must be less than " + maxChar + " characters";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else {
        this.userEmailError = "";
        document.getElementById("userEmail").classList.remove("formError");
        return true;
      }
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Utility__["a" /* default */]]
});

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(321);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b69fbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(387);
function injectStyle (ssrContext) {
  __webpack_require__(385)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13b69fbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b69fbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(386);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("6acdceea", content, true, {});

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".rest-popup[data-v-13b69fbe]{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:8888;overflow-y:scroll}.rest-popup .popup-box[data-v-13b69fbe]{position:fixed;background-color:#fff;z-index:8889;border-radius:4px;min-width:320px;top:45%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.rest-popup .popup-form[data-v-13b69fbe]{margin-top:10px}.rest-popup .box-header[data-v-13b69fbe]{padding:20px}.rest-popup .box-header h6[data-v-13b69fbe]{text-align:center;width:95%;float:left;text-transform:uppercase;font-weight:600;color:#000;font-size:25px}.rest-popup .box-header .header-close[data-v-13b69fbe]{position:relative;cursor:pointer;float:right;width:15px;top:5px}.rest-popup .popup-message[data-v-13b69fbe]{text-align:center;margin:1em;display:block}.session-exp-popup[data-v-13b69fbe]{margin:0 20%}.enter-your-email-id[data-v-13b69fbe]{margin:10% 0;color:#212121;font-size:17px;line-height:20px;font-family:ProximanovaRegular}.email-adress-label[data-v-13b69fbe]{color:#212121;font-family:ProximanovaBold;font-size:18px;line-height:22px;letter-spacing:.17px}.email-address[data-v-13b69fbe]{margin:2% 0 0;border-bottom:2px solid #e2e0e0}.reset-btn[data-v-13b69fbe]{margin:10% 0}.success-style[data-v-13b69fbe]{text-align:center;color:green;margin-bottom:20px}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Popups/ResetPassword.vue"],"names":[],"mappings":"AACA,6BAA6B,eAAe,MAAM,OAAO,WAAW,YAAY,gCAAiC,aAAa,iBAAiB,CAC9I,AACD,wCAAwC,eAAe,sBAAsB,aAAa,kBAAkB,gBAAgB,QAAQ,SAAS,uCAAwC,8BAA+B,CACnN,AACD,yCAAyC,eAAe,CACvD,AACD,yCAAyC,YAAY,CACpD,AACD,4CAA4C,kBAAkB,UAAU,WAAW,yBAAyB,gBAAgB,WAAY,cAAc,CACrJ,AACD,uDAAuD,kBAAkB,eAAe,YAAY,WAAW,OAAO,CACrH,AACD,4CAA4C,kBAAkB,WAAW,aAAa,CACrF,AACD,oCAAoC,YAAY,CAC/C,AACD,sCAAsC,aAAa,cAAc,eAAe,iBAAiB,8BAAgC,CAChI,AACD,qCAAqC,cAAc,4BAA8B,eAAe,iBAAiB,oBAAqB,CACrI,AACD,gCAAgC,cAAgB,+BAA+B,CAC9E,AACD,4BAA4B,YAAY,CACvC,AACD,gCAAgC,kBAAkB,YAAY,kBAAkB,CAC/E","file":"ResetPassword.vue","sourcesContent":["\n.rest-popup[data-v-13b69fbe]{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.7);z-index:8888;overflow-y:scroll\n}\n.rest-popup .popup-box[data-v-13b69fbe]{position:fixed;background-color:#fff;z-index:8889;border-radius:4px;min-width:320px;top:45%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)\n}\n.rest-popup .popup-form[data-v-13b69fbe]{margin-top:10px\n}\n.rest-popup .box-header[data-v-13b69fbe]{padding:20px\n}\n.rest-popup .box-header h6[data-v-13b69fbe]{text-align:center;width:95%;float:left;text-transform:uppercase;font-weight:600;color:black;font-size:25px\n}\n.rest-popup .box-header .header-close[data-v-13b69fbe]{position:relative;cursor:pointer;float:right;width:15px;top:5px\n}\n.rest-popup .popup-message[data-v-13b69fbe]{text-align:center;margin:1em;display:block\n}\n.session-exp-popup[data-v-13b69fbe]{margin:0 20%\n}\n.enter-your-email-id[data-v-13b69fbe]{margin:10% 0;color:#212121;font-size:17px;line-height:20px;font-family:\"ProximanovaRegular\"\n}\n.email-adress-label[data-v-13b69fbe]{color:#212121;font-family:\"ProximanovaBold\";font-size:18px;line-height:22px;letter-spacing:0.17px\n}\n.email-address[data-v-13b69fbe]{margin:2% 0 0 0;border-bottom:2px solid #e2e0e0\n}\n.reset-btn[data-v-13b69fbe]{margin:10% 0\n}\n.success-style[data-v-13b69fbe]{text-align:center;color:green;margin-bottom:20px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"width":_vm.width,"closePopupEvent":_vm.closePopupCB}},[_c('h6',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),(!_vm.showSuccessMessage)?_c('div',{staticClass:"session-exp-popup"},[_c('p',{staticClass:"enter-your-email-id"},[_vm._v("Enter your email id to reset password")]),_vm._v(" "),_c('FormError',{directives:[{name:"show",rawName:"v-show",value:(_vm.formError),expression:"formError"}],staticClass:"rst-pass-form-error",attrs:{"message":_vm.formError}}),_vm._v(" "),_c('div',{staticClass:"reset-pass-form popup-form"},[_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.resetPasswordCB($event)}}},[_c('input',{staticStyle:{"display":"none"},attrs:{"autocomplete":"false","name":"hidden","type":"text"}}),_vm._v(" "),_c('div',{staticClass:"vlt-input-group"},[_c('label',{staticClass:"email-adress-label"},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userEmail),expression:"userEmail"}],ref:"userEmail",staticClass:"email-address",attrs:{"id":"userEmail","type":"email","maxlength":"128"},domProps:{"value":(_vm.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userEmail=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.userEmailError))])]),_vm._v(" "),_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}]}),_vm._v(" "),_c('div',{staticClass:"reset-btn"},[_c('button',{ref:"loginBtnSubmit",staticClass:"btn-lg-primary",attrs:{"type":"submit"}},[_vm._v("Request")])])],1)])],1):_c('div',{staticClass:"success-style"},[_c('h5',[_vm._v(_vm._s(_vm.showSuccessMessage))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/34.35f887f3613c2233258f.js